import { NavigateToPreviousLink } from '@/components/common/NavigateToPreviousLink/NavigateToPreviousLink'
import { PropsWithChildren, ReactNode } from 'react'

type ReportHeaderProps = PropsWithChildren & {
    backToPath?: string
    backToLabel?: string
    title: string
    renderTitle?: () => ReactNode
}

export const ReportHeader: React.FC<ReportHeaderProps> = (props) => {
    const { backToPath, backToLabel, renderTitle, title, children } = props

    return (
        <>
            <div className="space-y-2">
                {backToLabel && backToPath && (
                    <NavigateToPreviousLink
                        to={backToPath}
                        label={backToLabel}
                    />
                )}
                <div className="relative z-40 flex items-center justify-between gap-2 pr-6 lining-nums">
                    <div className="grow basis-0 overflow-hidden">
                        {renderTitle ? renderTitle() : title}
                    </div>
                    {children}
                </div>
            </div>
        </>
    )
}
